// @ts-strict-ignore
import { buildHeaderContent } from "components/parts/ParseRichText";
import kebabCase from "lodash/kebabCase";

type HeadingType =
  | "heading-1"
  | "heading-2"
  | "heading-3"
  | "heading-4"
  | "heading-5"
  | "heading-6";

export interface TableOfContents {
  anchor: string;
  url: string;
  isMainHeader: boolean;
}

export const getHeaders = (
  pageContent: any,
  mainHeader: HeadingType = "heading-3",
  subHeader: HeadingType = "heading-4"
): TableOfContents[] =>
  pageContent
    .filter(
      (node) => node.nodeType === mainHeader || node.nodeType === subHeader
    )
    .map((node) => {
      const anchorContent = buildHeaderContent(node.content);
      if (node.nodeType === mainHeader) {
        return {
          anchor: anchorContent,
          url: `#section-${kebabCase(anchorContent)}`,
          isMainHeader: true
        };
      }
      if (node.nodeType === subHeader) {
        return {
          anchor: anchorContent,
          url: `#section-${kebabCase(anchorContent)}`,
          isMainHeader: false
        };
      }
    });
